<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>
<div class="px-4">
  <div class="w-100">
    <div class="row" [hidden]="skelition">
      <div class="v4-p-table">
        <p-treeTable #tt *ngIf="data.length > 0" [value]="data" [columns]="cols" [paginator]="true" [rows]="10"
          [scrollable]="true">
          <ng-template pTemplate="caption">
            <input dir="rtl" class="ms-input-view" type="text" [(ngModel)]="globalFilter" placeholder="بحث"
              (input)="tt.filterGlobal(globalFilter,'contains')" />
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th [ngStyle]="colIndex == 0 ? {'width':'20%'}: {'width':'8%'}"
                *ngFor="let col of columns;let colIndex=index">
                {{ col.header }}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr
              [style]="rowData.hasOwnProperty('_id') ? 'background-color:transparent; color:white;' : 'background-color:rgba(34, 33, 54, 0.5)'">
              <td [ngStyle]="i == 0 ? {'width':'20%'}: {'width':'8%'}" *ngFor="let col of columns; let i = index">
                <div *ngIf="col.field != 'Action';else action" class="{{i == 0 ? 'd-flex flex-row gap-1' : ''}}">
                  <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                  <span>{{ rowData[col.field] }}</span>
                </div>
                <ng-template #action>
                  <p-button *ngIf="rowData.hasOwnProperty('_id') && hasPermission('d')" icon="pi pi-times"
                    styleClass="p-button-rounded p-button-danger mx-1"
                    (onClick)="actionCall({id:rowNode.node.data._id,action:'Delete'})"></p-button>
                  <p-button *ngIf="rowData.hasOwnProperty('_id') && hasPermission('u')" icon="pi pi-file-edit"
                    styleClass="p-button-rounded p-button-warning mx-1"
                    (onClick)="actionCall({data:rowNode,action:'Update'})"></p-button>
                </ng-template>
              </td>

            </tr>
          </ng-template>
        </p-treeTable>
      </div>

    </div>
  </div>
</div>
<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>
<!-- Confirm Modal -->
<p-confirmDialog [style]="{margin: '0rem 1rem'}"></p-confirmDialog>


<app-footer></app-footer>